/**
 * 注册全局组件
 */
import type { App } from 'vue';
// 基础布局
import MkLayout from '@components/mk-layout';
// 底部分享按钮
import MkFooterShare from '@components/mk-footer-share';
// 联系我组件
import MkLinkMe from '@components/mk-link-me';
// 提示
import MkTips from '@components/mk-tips';
// 底部发送按钮
import MkFooterSend from '@components/mk-footer-send';
// 空组件
import MkNoStatus from '@components/mk-no-status';
// 返回按钮
import MkReturnBar from '@components/mk-return-bar';

export default {
  install(app: App) {
    app.component(MkLayout.name as string, MkLayout);
    app.component(MkNoStatus.name as string, MkNoStatus);
    app.component(MkFooterShare.name as string, MkFooterShare);
    app.component(MkLinkMe.name as string, MkLinkMe);
    app.component(MkTips.name as string, MkTips);
    app.component(MkFooterSend.name as string, MkFooterSend);
    app.component(MkReturnBar.name as string, MkReturnBar);
  }
};
